/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *  [P7B.1 §2] THE REVIEW SITE'S CHIP VOCABULARY, IN THIS PRODUCT'S TOKENS — four shapes, and no hue.
 *
 *  The policing team verified the booklet on the review site, so its chips are words they already
 *  read: plain for a fact, inverted for "Not in PAMS" (nothing here has this code yet), emphasis for
 *  "look at this" (probable, differs, proposed), dashed for "a role, not a unit".
 *
 *  ⚠️ THE REVIEW SITE'S ACCENT IS NOT `info` HERE. Across PAMS a blue badge means "not a problem"
 *  (Draft, Published, an overlap that is fine), and a "Differs" chip is a decision holding templates
 *  back — so emphasis is the strong border and the stronger wash, in the neutral tokens. Status hues
 *  keep their one meaning, fill state, and a chip never borrows one.
 *
 *  ⚠️ A CHIP IS FOR A DETAIL PANE OR THE DECISIONS PANEL, NEVER A LIST ROW — a row says its state with
 *  one dot and a muted line, which is `DESIGN_LANGUAGE.md`'s rule for a list.
 *
 *  The map is here and not in `BookletChip.tsx`, because `react-refresh/only-export-components`
 *  refuses a constant exported beside a component, and the contrast test reads the classes.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
export type BookletChipVariant = 'plain' | 'accent' | 'unmapped' | 'role';

export const BOOKLET_CHIP_BASE =
  'inline-flex shrink-0 items-center whitespace-nowrap rounded-md border px-1.5 text-xs leading-[18px]';

export const BOOKLET_CHIP_CLASS: Record<BookletChipVariant, string> = {
  plain: 'border-border text-muted-foreground',
  accent: 'border-input bg-active font-medium text-foreground',
  unmapped: 'border-foreground bg-foreground text-background',
  role: 'border-dashed border-input text-muted-foreground',
};
